import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountingService } from 'src/app/services/accounting/accounting.service';
import * as moment  from 'moment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-balancesheet-report-print',
  templateUrl: './balancesheet-report-print.component.html',
  styleUrls: ['./balancesheet-report-print.component.css']
})
export class BalancesheetReportPrintComponent implements OnInit {

  PaymentModelSearch = {
    AccID: 0,
    FromDate: '',
    ToDate: ''
};
  TransID=0;
  constructor(private activatedRoute:ActivatedRoute,private accService:AccountingService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { 
    this.activatedRoute.queryParams.subscribe(params => {
     
      this.PaymentModelSearch.FromDate = params['FromDate'];
      this.PaymentModelSearch.ToDate = params['ToDate'];
      
      this.GetBalancesheetReport ();
  });
  }
  loadingSearch = false;
  AccountList:any;
  BranchDetails:any;
  GetBalancesheetReport  () {
  
      this.loadingSearch = true;
      this.spinnerService.show();
     
      this.accService.GetBalancesheetReport(JSON.stringify(this.PaymentModelSearch)).subscribe( (response)=> {
          this.AccountList = response.AccountList;
          this.BranchDetails = response.BarnchDetails;
          setTimeout( ()=>{
            this.spinnerService.hide();
              this.loadingSearch = false;
              this.globalHelper.CheckActionStatus(response);
          }, 10);
      });
  };
  ngOnInit() {
  }

}
